export default __webpack_public_path__ + "static/media/img-0512-croatia-full-face.b125d6ec.png";